import moment from 'moment';
export function getRamdomDate() {
	const newDate = moment(Math.floor(Math.random() * Date.now()));

	return newDate.locale('en').format('DD MMM YY');
}
export function formatDate(date) {
	const dateToFormat = moment(date);
	return dateToFormat.locale('en').format('DD MMM YY');
}